/*------------------------------------*\
    SITE NAV
\*------------------------------------*/
class Tabs {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
    }

    init() {
        let self = this;

        let firstTrigger = self.elem.querySelector('.js-tabs__trigger');
        let firstPanel = self.elem.querySelector('.js-tabs__panel');
        let triggers = self.elem.querySelectorAll('.js-tabs__trigger');
        let panels = self.elem.querySelectorAll('.js-tabs__panel');

        // Active the first trigger & panel
        firstTrigger.classList.add('is-active');
        firstPanel.classList.add('is-active');

        // For each tab trigger
        Array.from(triggers).forEach(trigger => {

            // When the trigger is clicked...
            trigger.addEventListener('click', evt => {
                // Prevent the default click action
                evt.preventDefault();

                // Get the ID of the related panel
                let relatedPanelId = trigger.getAttribute('href');
                let relatedPanel = self.elem.querySelector(relatedPanelId);

                // Remove active class from all triggers
                Array.from(triggers).forEach(trigger => {
                    trigger.classList.remove('is-active');
                });

                // Close all tabs
                Array.from(panels).forEach(panel => {
                    panel.classList.remove('is-active');
                });

                // Activate the clicked trigger
                trigger.classList.add('is-active');

                // Reveal the related panel
                relatedPanel.classList.add('is-active');

            });

        });
    }
}

export default Tabs;
